<template>
  <v-content class="mt-0 pt-0" style="min-width: 450px">
  <v-container fluid>
    <pr-loading v-model="loading" />
    <v-snackbar v-model="msg.show" value="true" right top multi-line :color="msg.type" :timeout="msg.time" >
      <div v-html="msg.text"></div>
      <v-btn dark flat @click="msg.show = false">
        {{ $t('OK') }}
      </v-btn>
    </v-snackbar>

    <v-dialog v-model="printOpts.show" max-width="500px" transition="dialog-transition" persistent>
      <v-card>
        <v-card-title>
          <span class="headline px-3">{{ $t('Print PDF options') }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12>
                <v-switch :label="$t('Freight amount')" v-model="printOpts.price"></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-switch :label="$t('Insurance amount')" v-model="printOpts.insurance"></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="printOpts.items = []; printOpts.show = false">{{ $t('Cancel') }}</v-btn>
          <v-btn color="blue darken-1" flat @click.native="printItem(); printOpts.show = false">
            <v-icon>print</v-icon>&nbsp;{{ $t('Print' ) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <RouteTracking v-model="routeTracking.show" @show="routeTracking.show = $event"
      :shipment="routeTracking.shipment"
      @msg-popup="(msg, type) => msg(msg, type)"
    ></RouteTracking>

    <v-toolbar flat color="white" class="elevation-1">
      <v-toolbar-title>{{ $t('my shipments screen') }}</v-toolbar-title>
      <v-divider vertical class="ml-3 mr-2"></v-divider>
      <v-tooltip bottom>
        <v-switch slot="activator"
          :label="$t('Being delivered')"
          :input-value="getFilter('state.active').filter"
          @change="onFilter('state.active', null)"
          hide-details
          color="success"
          class="mx-2"
        ></v-switch>
        <span v-if="getFilter('state.active').filter">{{ $t('Show all shipments') }}</span>
        <span v-else>{{ $t('Shipments being delivered') }}</span>
      </v-tooltip>
      <div bottom @click="onFilterMore">
        <v-tooltip bottom>
          <v-checkbox slot="activator"
            :label="$t('Shipments.More')"
            :input-value="filterMore.filter"
            readonly
            :loading="filterMore.allowing"
            :disabled="filterMore.disabled"
            hide-details
            color="success"
            class="mx-2"
          ></v-checkbox>
          <span v-if="filterMore.filter">{{ $t('Shipments.Less.Tooltip') }}</span>
          <span v-else>{{ $t('Shipments.More.Tooltip') }}</span>
        </v-tooltip>
      </div>
      <div bottom @click="onFilter('manifest_forward')">
        <v-tooltip bottom>
          <v-checkbox slot="activator"
            :label="$t('Shipments.Forward')"
            :input-value="getFilter('manifest_forward').filter"
            readonly
            :disabled="loading"
            hide-details
            color="success"
            class="mx-2"
          ></v-checkbox>
          <span>{{ $t('Shipments.Forward.Tooltip') }}</span>
        </v-tooltip>
      </div>
      <div @click="onFilter('manifest_od')">
        <v-tooltip bottom>
          <v-checkbox slot="activator"
            :label="$vuetify.breakpoint.mdOnly ? $t('Shipments.OD') : $t('Price.RETURN_DOCS')"
            :input-value="getFilter('manifest_od').filter"
            readonly
            :disabled="loading"
            hide-details
            color="success"
            class="mx-2"
          ></v-checkbox>
          <span>{{ $t('Shipments.OD.Tooltip') }}</span>
        </v-tooltip>
      </div>
      <div @click="onFilter('manifest_vto')">
        <v-tooltip bottom>
          <v-checkbox slot="activator"
            :label="$vuetify.breakpoint.mdOnly ? $t('Shipments.VTO') : $t('Price.RETURN_PACKAGING')"
            :input-value="getFilter('manifest_vto').filter"
            readonly
            :disabled="loading"
            hide-details
            color="success"
            class="mx-2"
          ></v-checkbox>
          <span>{{ $t('Shipments.VTO.Tooltip') }}</span>
        </v-tooltip>
      </div>
      <v-spacer></v-spacer>
      <!-- Bulk actions: Order/Request, Cancel, Print, Label -->
      <v-toolbar-items style="height: auto">
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="orderItems" :disabled="notAcceptedIds.length == 0">
            <v-icon class="text--secondary">shop</v-icon>
          </v-btn>
          <span>{{ $t('Order selected') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="cancelItems" :disabled="cancellableIds.length == 0">
            <v-icon class="text--secondary">cancel</v-icon>
          </v-btn>
          <span>{{ $t('Cancel selected') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="printMenu()" :disabled="acceptedIds.length == 0">
            <v-icon class="text--secondary">print</v-icon>
          </v-btn>
          <span>{{ $t('Print selected') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="labelItem()" :disabled="acceptedIds.length == 0">
            <v-icon class="text--secondary">label</v-icon>
          </v-btn>
          <span>{{ $t('Label selected') }}</span>
        </v-tooltip>
        <!--/ Bulk actions end -->
      </v-toolbar-items>
      <v-divider vertical inset class="mx-2"></v-divider>
      <v-tooltip bottom>
        <v-btn icon slot="activator" @click="exportExcel" v-shortkey="['ctrl', 'alt', 'e']" @shortkey="exportExcel">
          <v-icon class="text--secondary">far fa-file-excel</v-icon>
        </v-btn>
        <span>{{ $t('Export to Excel') }}</span>
      </v-tooltip>
      <v-divider vertical inset class="mx-2"></v-divider>
      <v-tooltip bottom>
        <v-btn icon slot="activator" @click="resetFilters" :disabled="!strFiltersOn">
          <v-icon class="text--secondary">search_off</v-icon><!-- find_replace, search_off -->
        </v-btn>
        <span>{{ $t('Reset filters') }}: {{ strFiltersOn }}</span>
      </v-tooltip>
      <v-tooltip bottom v-if="false">
        <v-btn icon slot="activator" @click="exportPdf" v-shortkey="['ctrl', 'alt', 'p']" @shortkey="exportPdf">
          <v-icon class="text--secondary">far fa-file-pdf</v-icon>
        </v-btn>
        <span>{{ $t('Export to PDF') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-menu slot="activator"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
          left
        >
          <v-btn icon slot="activator">
            <v-icon v-if="headers.some(header => !header.show)" class="text--secondary">settings_suggest</v-icon>
            <v-icon v-else class="text--secondary">settings</v-icon>
          </v-btn>

          <v-card>
            <v-list>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ $t('Table settings') }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ $t('Select visible columns') }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-divider></v-divider>

            <v-list dense>
              <v-list-tile v-for="(header,key) in headers.filter(header => header.value !== 'actions')" :key="'col-'+key" @click="header.show = !header.show; store()">
                <v-list-tile-action>
                  <v-switch :value="header.show" :input-value="header.show" color="primary" :disabled="columnHideCheck(header)"></v-switch>
                </v-list-tile-action>
                <v-list-tile-title>{{ header.text }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
        <span>{{ $t('Table settings') }}</span>
      </v-tooltip>
    </v-toolbar>

    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :headers="headers.filter(elem => !!elem.show)"
          :items="items"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :loading="loading"
          :rows-per-page-items="[5, 10, 25]"
          :rows-per-page-text="$t('Rows per page')"
          :no-data-text="$t('No data')"
          :no-results-text="$t('No results')"
          class="elevation-1 shipments-table"
          v-model="selected" select-all
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th class="sticky-left">
                <v-checkbox
                  :input-value="props.all"
                  :indeterminate="props.indeterminate"
                  primary
                  hide-details
                  @click.stop="toggleAll"
                ></v-checkbox>
              </th>
              <th
                v-for="(header,idx) in props.headers"
                :key="header.value"
                class="px-2"
                :class="[
                  'column',
                  header.sortable && 'sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy && 'active',
                  hasFilter(header) && 'filtered',
                  header.value == 'manifest' && 'sticky-left outer',
                  header.value == 'actions' && 'sticky-right outer'
                ]"
              >
                <v-layout row class="align-center">
                  <v-flex>
                    <v-btn v-if="header.sortable" @click="changeSort(header)" icon small class="ma-0">
                      <v-icon small>arrow_upward</v-icon>
                    </v-btn>
                  </v-flex>

                  <v-flex class="pa-1">
                    <v-tooltip v-if="hasFilter(header)" bottom>
                      <span slot="activator" style="white-space: normal">{{ header.text }}</span>
                      <span>{{ $t('Filter:') }} {{ filterTooltip(header) }}</span>
                    </v-tooltip>
                    <span v-else style="white-space: normal">{{ header.text }}</span>
                  </v-flex>

                  <!-- Filter -->
                  <v-flex v-if="header.hasOwnProperty('filter')">

                    <v-menu
                      v-model="filterActives[idx]"
                      :close-on-content-click="false"
                      bottom left
                      offset-y nudge-top="12" nudge-right="22"
                      max-width="360px"
                      :min-width="(header.value === 'state' ? '320px' : '')"
                      offset-overflow
                      content-class="shipments-filter"
                    >

                      <!-- Icon (open filter dialog) -->
                      <v-btn icon small right depressed slot="activator" class="filter"
                        @click="filterFocus(idx)"
                      >
                        <v-icon small>search</v-icon>
                      </v-btn>

                      <!-- Close filter dialog Icon -->
                      <v-btn absolute fab small class="elevation-2 ma-0"
                        dark color="primary"
                        top right
                        @click="filterActives = []"
                      >
                        <v-icon>close</v-icon>
                      </v-btn>

                      <!-- Filter dialog window -->
                      <v-card>
                        <v-card-text>

                          <v-autocomplete v-if="header.value === 'service_type'"
                            v-model="header.filter"
                            :label="$t('Filter by') + ' ' + header.text"
                            :items="serviceTypes"
                            item-value="value"
                            multiple cache-items dense
                            :menu-props="{ lazy : '', maxHeight : 'auto' }"
                            :hint="$t('Multiple values can be selected')" persistent-hint
                            @keyup.esc="filterActives = []" @keyup.enter="filterActives = []"
                            :id="'filter-' + idx + '-body'"
                          >
                            <template slot="selection" slot-scope="data">
                              <v-tooltip bottom>
                                <v-chip slot="activator"
                                  :selected="data.selected"
                                  close
                                  class="chip--select-multi"
                                  @input="data.parent.selectItem(data.item)"
                                  text-color="primary"
                                >
                                  <v-avatar color="indigo" class="mr-2 headline font-weight-light white--text">
                                    {{ data.item.shortText }}
                                  </v-avatar>
                                  <span class="caption">{{ $t('ServiceType.' + data.item.value) }}</span>
                                </v-chip>
                                <span>{{ $t('ServiceType.' + data.item.value + '.explain') }}</span>
                              </v-tooltip>
                            </template>
                            <template slot="item" slot-scope="data">
                              <v-list-tile-avatar size="32" color="indigo" class="headline font-weight-light white--text">
                                {{ data.item.shortText }}
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title>{{ $t('ServiceType.' + data.item.value) }}</v-list-tile-title>
                              </v-list-tile-content>
                            </template>
                          </v-autocomplete>

                          <v-autocomplete v-else-if="header.value === 'state'"
                            v-model="header.filter"
                            :label="$t('Filter by') + ' ' + header.text"
                            :items="states"
                            item-value="code" item-text="display"
                            multiple cache-items dense
                            :menu-props="{ lazy : '' }"
                            :hint="$t('Multiple values can be selected')" persistent-hint
                            @keyup.esc="filterActives = []" @keyup.enter="filterActives = []"
                            :id="'filter-' + idx + '-body'"
                          >
                            <template slot="selection" slot-scope="data">
                              <v-tooltip bottom>
                                <v-chip slot="activator"
                                  :selected="data.selected"
                                  close
                                  class="chip--select-multi"
                                  @input="data.parent.selectItem(data.item)"
                                  text-color="primary"
                                >
                                  <v-avatar v-if="header.icon" class="mr-0">
                                    <v-icon small>{{ getStateIcon(data.item) }}</v-icon>
                                  </v-avatar>
                                  <span class="caption">{{ typeof data.item.display === 'string' ? data.item.display.substring(0,3) : '' }}</span>
                                </v-chip>
                                <span>{{ typeof data.item.display === 'string' ? data.item.display.substring(4) : '' }}</span>
                              </v-tooltip>
                            </template>

                            <template slot="item" slot-scope="data">
                              <v-list-tile-avatar v-if="header.icon">
                                <v-icon small>{{ getStateIcon(data.item) }}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title>{{ data.item.display }}</v-list-tile-title>
                              </v-list-tile-content>
                            </template>

                          </v-autocomplete>

                          <template v-else-if="header.value === 'order_date' || header.value === 'state_date' || header.filterName === 'source_date' || header.filterName === 'target_date'">
                            <v-container grid-list-md pa-0>

                              <v-layout wrap>
                                <v-flex xs6 style="position: relative">
                                  <v-input-date-picker
                                    v-model="header.filter.since"
                                    :id="'filter-' + idx + '-body'"
                                    :label="$t('Date from')"
                                    icon="event"
                                    hide-details
                                    clearable
                                    iso
                                    :max="getMaxDate(header.filterName)"
                                  ></v-input-date-picker>
                                </v-flex>
                                <v-flex xs6 style="position: relative">
                                  <v-input-date-picker
                                    v-model="header.filter.until"
                                    :label="$t('Date to')"
                                    icon="date_range"
                                    hide-details
                                    clearable
                                    iso
                                    :max="getMaxDate(header.filterName)"
                                  ></v-input-date-picker>
                                </v-flex>

                              </v-layout>
                            </v-container>
                          </template>

                          <template v-else-if="header.value === 'creator'">
                            <v-container grid-list-md pa-0>
                              <v-layout wrap>
                                <v-flex xs6 style="position: relative">

                                  <v-select
                                    :label="$t('Filter by creator type')"
                                    :items="CREATOR_TYPES"
                                    v-model="header.filter.creator_type"
                                    @change="header.filter.creator_type !== 'CLIENT_USER' ? header.filter.creator_user = null : null"
                                    hide-details
                                    required
                                  ><template slot="selection" slot-scope="{ item }">
                                      {{ $t('CREATOR_TYPE.' + item) }}
                                    </template>
                                    <template slot="item" slot-scope="{ item }">
                                      <v-list-tile-content>
                                        <v-list-tile-title v-text="$t('CREATOR_TYPE.' + item)"></v-list-tile-title>
                                      </v-list-tile-content>
                                    </template></v-select>

                                </v-flex>
                                <v-flex xs6 style="position: relative">

                                  <v-text-field
                                    :label="$t('Filter by creator user')"
                                    v-model="header.filter.creator_user"
                                    :required="header.filter.creator_type === 'CLIENT_USER'"
                                    :disabled="header.filter.creator_type !== 'CLIENT_USER'"
                                    clearable @click:clear="header.filter.creator_user = null"
                                    prepend-icon="person_search"
                                    hide-details
                                  ></v-text-field>
                                </v-flex>

                              </v-layout>
                            </v-container>
                          </template>

                          <template v-else-if="header.type === 'boolean'">
                            <v-checkbox
                              v-model="header.filter"
                              :label="$t('Filter by') + ' ' + header.text"
                              hide-details
                              on-icon="done" off-icon="close"
                              @keyup.esc="filterActives = []" @keyup.enter="filterActives = []"
                              :id="'filter-' + idx + '-body'"
                            >
                              <template slot="label">
                                {{ $t('Filter by') + ' ' + header.text }}
                                <v-icon
                                  class="ml-2"
                                  @click.stop="header.filter = null; filterActives = []"
                                >search_off</v-icon>
                              </template>
                            </v-checkbox>
                          </template>

                          <v-text-field v-else
                            v-model="header.filter"
                            :label="$t('Filter by') + ' ' + header.text"
                            prepend-icon="search"
                            hide-details
                            clearable clear-icon="search_off"
                            :type="getFieldType(idx)"
                            @keyup.esc="filterActives = []" @keyup.enter="filterActives = []"
                            :id="'filter-' + idx + '-body'"
                          ></v-text-field>

                        </v-card-text>
                      </v-card>
                    </v-menu>

                  </v-flex>
                </v-layout>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr :active="props.selected" :class="[getRowBackground( props.item ), (props.index % 2 ? '' : 'even lighten-3')]">
              <td class="sticky-left">
                <v-checkbox
                  v-model="props.selected"
                  primary
                  hide-details
                ></v-checkbox>
              </td>

              <td v-for="(header,idx) in headers" :key="idx" v-if="header.show && header.value !== 'actions'"
                :class="[
                  getColumnAlign(idx),
                  (header.value == 'manifest' && 'sticky-left outer'),
                  ('cell-' + header.value)
                ]" class="px-2"
              >
                <v-tooltip v-if="header.tooltip" bottom>
                  <v-icon slot="activator" small left v-if="header.icon">{{ getObjectIcon(props.item, idx)}}</v-icon>
                  <span slot="activator" v-else v-html="getObjectValue(props.item, idx, header)"></span>
                  <span v-html="getObjectValue(props.item, idx, header)"></span>
                </v-tooltip>
                <div v-else>
                  <v-icon small left v-if="header.icon">{{ getObjectIcon(props.item, idx, header)}}</v-icon>
                  <span v-html="getObjectValue(props.item, idx, header)"></span>
                </div>
              </td>

              <td class="justify-center pl-4 pr-1 sticky-right outer">
                <v-tooltip bottom>
                  <v-btn slot="activator" icon small class="mx-0" @click="editItem(props.item)">
                    <v-icon small class="text--secondary">{{ isShipmentReadonly(props.item) ? 'edit_off' : 'edit' }}</v-icon>
                  </v-btn>
                  <span>{{ $t(isShipmentReadonly(props.item) ? 'Preview' : 'Edit') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" icon small class="mx-0" @click="trackItem(props.item)">
                    <v-icon small class="text--secondary">search</v-icon>
                  </v-btn>
                  <span>{{ $t('Track') }} ({{ $t('In a new tab or window') }})</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" icon small class="mx-0" @click="routeTrackItem(props.item)">
                    <v-icon small class="text--secondary">route</v-icon>
                  </v-btn>
                  <span>{{ $t('Routing tracking') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" icon small class="mx-0" @click="editItemAsNew(props.item)">
                    <v-icon small class="text--secondary">content_copy</v-icon>
                  </v-btn>
                  <span>{{ $t('Copy and edit') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" icon small class="mx-0" :disabled="!props.item.accepted" @click="printMenu(props.item)">
                    <v-icon small class="text--secondary">print</v-icon>
                  </v-btn>
                  <span>{{ $t('Print') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" icon small class="mx-0" :disabled="!props.item.accepted" @click="labelItem(props.item)">
                    <v-icon small class="text--secondary">label</v-icon>
                  </v-btn>
                  <span>{{ $t('Label item') }}</span>
                </v-tooltip>

                <v-hover v-model="attachmentTooltips[props.index]" :id="'attachment-' + props.item.id">

                <v-menu :disabled="!getAttachmentsLength(props.item.attachments)" min-width="480px">

                  <v-badge
                    slot="activator"
                    :value="getAttachmentsLength(props.item.attachments) > 0"
                    overlap
                    color="primary"
                  >
                    <template v-slot:badge>
                      <span>{{ getAttachmentsLength(props.item.attachments) }}</span>
                    </template>
                    <v-btn icon small class="attachments ml-0"
                      @click="!getAttachmentsLength(props.item.attachments) && podInfo(props.item)"
                      :color="!getAttachmentsLength(props.item.attachments) ? 'grey--text text--lighten-1' : 'text--secondary'"
                      :loading="props.item.attachmentLoading"
                    >
                      <v-icon small>attach_email</v-icon>
                    </v-btn>
                  </v-badge>
                  <v-card><v-card-text class="px-2 pt-2 pb-1">

                    <v-list two-lines subheader>
                      <template v-for="attch in props.item.attachments">
                        <v-list-tile :key="attch.id" @click="downloadAttachment(props.item, attch.id)">
                          <v-list-tile-avatar>
                            <v-tooltip bottom>
                              <v-list-tile-avatar slot="activator" :color="getAttachmentColor(attch.type) + ' white--text'">
                                {{ $t('ATTACHMENT.TYPE.' + (attch.type || 'NUL')) }}
                              </v-list-tile-avatar>
                              <v-icon small color="white">get_app</v-icon>{{ $t('Download') }}
                              {{ $t('ATTACHMENT.TYPE.' + (attch.type || 'NUL') + '.TEXT') }}
                            </v-tooltip>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title v-if="attch.name" class="font-weight-bold" :class="getAttachmentColor(attch.type) + '--text'">{{ attch.name }}</v-list-tile-title>
                            <v-list-tile-title v-else            class="font-italic grey--text">{{ $t('untitled') }}</v-list-tile-title>
                            <v-list-tile-sub-title>
                              <span class="text--primary">{{ attch.fileName }}</span>
                              <span class="float-right">
                                {{ attch.fileSize }} B
                                <span class="mx-2">&mdash;</span>
                                {{ formatDatetime(attch.fileDate) }}
                              </span>
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>
                      </template>
                    </v-list>

                    <v-tooltip bottom>
                      <v-btn slot="activator" block depressed dark color="primary" @click="downloadAttachment(props.item)">
                        <v-icon small left>get_app</v-icon>
                        {{ $t('Download all') }}
                      </v-btn>
                      <span>{{ $t('Download all attachments') }}</span>
                    </v-tooltip>

                  </v-card-text></v-card>
                </v-menu>

                </v-hover>
                <v-tooltip :value="attachmentTooltips[props.index]" :attach="'#attachment-' + props.item.id" content-class="attachment-tooltip">
                  {{ $t(!getAttachmentsLength(props.item.attachments) ? 'Reload attachments info' : 'View/download attachments') }}
                </v-tooltip>

              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination v-model="pagination.page" :length="pages" circle total-visible="7"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
  </v-content>
</template>

<script>
import _object from "lodash/object";
import { debounce, escape } from "lodash";
import { shipments, attachments } from "../resources";
import { getStateIcon, downloadFile, getDefaultServiceTypes, attachmentTypes, msg, extractBodyErrorMessages, isShipmentReadonly, showDualAmount } from "../components/util";
import { mapGetters, mapActions } from "vuex";
import PrLoading from '@/components/Loading.vue';
import VServiceSelector from "../components/VServiceSelector.vue";
import VSelectEnum from "../components/VSelectEnum.vue";
import VInputDatePicker from "../components/VInputDatePicker.vue";
import RouteTracking from "../views/RouteTracking.vue";


export default {
  components: {
    PrLoading,
    VServiceSelector,
    VSelectEnum,
    VInputDatePicker,
    RouteTracking
  },
  data () {
    return {
      msg,

      search: '',
      totalItems: 0,
      items: [],
      loading: false,
      pagination: {
        sortBy: 'order_date',
        descending: true,
        page: 1
      },
      resetPage: false,
      filterActives: [],
      filters: [// added 2021-03-04 as a holder of additional filters - in addition to this.headers (headers[n].filter|filterName
        { filterName: 'state.active',     filter: null },
        { filterName: 'more',             filter: null, disabled: false, allowing: false },
        { filterName: 'manifest_forward', filter: true },
        { filterName: 'manifest_od',      filter: true },
        { filterName: 'manifest_vto',     filter: true }
      ],
      itemsLoaded: null,
      selected: [],
      printOpts: { show: false, price: true, insurance: true, items: [] },

      headers: [
        { text: this.$t('Manifest'),              value: 'manifest',              align: 'left',   sortable: true,  show: true, filter: null, persistent: true },
        { text: this.$t('Reference'),             value: 'reference',             align: 'center', sortable: true,  show: true, filter: null },
        { text: this.$t('Date'),                  value: 'order_date',            align: 'center', sortable: true,  show: true, type: 'datetime', sortBy: true, filter: { since: null, until: null } },
        { text: this.$t('Service Type'),          value: 'service_type',          align: 'center', sortable: true,  show: true, type: 'enum', enum: 'ServiceType', filter: null },
        { text: this.$t('Tracking State'),        value: 'state',                 align: 'center', sortable: true,  show: true, type: this.showShipmentState, tooltip: true, icon: true, filter: null, filterName: 'state.code' },
        { text: this.$t('State Date'),            value: 'state_date',            align: 'center', sortable: true,  show: true, type: 'datetime',               filter: { since: null, until: null } },
        { text: this.$t('Pickup Date'),           value: 'source',                align: 'center', sortable: true,  show: true, type: this.showDateRange,       filter: { since: null, until: null }, filterName: 'source_date' },
        { text: this.$t('Source Partner'),        value: 'source.partner.name',   align: 'center', sortable: true,  show: true, filter: null },
        { text: this.$t('Source Address'),        value: 'source.address',        align: 'left',   sortable: true,  show: true, filter: null },
        { text: this.$t('Source Person'),         value: 'source.person',         align: 'left',   sortable: true,  show: true, filter: null },
        { text: this.$t('Source Phone'),          value: 'source.phone',          align: 'left',   sortable: false, show: true, filter: null },
        { text: this.$t('Delivery Date'),         value: 'target',                align: 'center', sortable: true,  show: true, type: this.showDateRange,       filter: { since: null, until: null }, filterName: 'target_date' },
        { text: this.$t('Target Partner'),        value: 'target.partner.name',   align: 'center', sortable: true,  show: true, filter: null },
        { text: this.$t('Target Address'),        value: 'target.address',        align: 'left',   sortable: true,  show: true, filter: null },
        { text: this.$t('Target Person'),         value: 'target.person',         align: 'left',   sortable: true,  show: true, filter: null },
        { text: this.$t('Target Phone'),          value: 'target.phone',          align: 'left',   sortable: false, show: true, filter: null },
        { text: this.$t('COD Amount'),            value: 'cash_on_delivery',      align: 'right',  sortable: true,  show: true, type: showDualAmount, filter: null, filterName: 'cash_on_delivery.amount' },
        { text: this.$t('Postal Money Transfer'), value: 'postal_money_transfer', align: 'center', sortable: false, show: true, type: 'boolean', tooltip: true, icon: true, filter: null },
        { text: this.$t('Packaging Type'),        value: 'packaging_type',        align: 'center', sortable: true,  show: true, type: this.showPackagingType },
        { text: this.$t('Parcel count'),          value: 'parcel_count',          align: 'right',  sortable: false, show: true, filter: null },
        { text: this.$t('Weight'),                value: 'weight',                align: 'right',  sortable: false, show: true, filter: null },
        { text: this.$t('Price'),                 value: 'price',                 align: 'right',  sortable: false, show: true, type: showDualAmount, filter: null, filterName: 'price.amount' },
        { text: this.$t('Review'),                value: 'review_on_delivery',    align: 'center', sortable: false, show: true, type: 'boolean', tooltip: true, icon: true, filter: null },
        { text: this.$t('Test'),                  value: 'test_on_delivery',      align: 'center', sortable: false, show: true, type: 'boolean', tooltip: true, icon: true, filter: null },
        { text: this.$t('Creator'),               value: 'creator',               align: 'left',   sortable: false, show: true, type: this.showCreator, filter: { creator_type: null, creator_user: null } },
        { text: this.$t('Description'),           value: 'description',           align: 'left',   sortable: false, show: true, filter: null },
        { text: this.$t('Actions'),               value: 'actions',               align: 'center', sortable: false, show: true },
      ],

      states: [],

      CREATOR_TYPES: [
        'CLIENT_USER',
        'GENERIC_IMPORT',
        'COMPANY_USER'
      ],

      attachmentTooltips: [],
      routeTracking: {
        show: false,
        shipment: {}
      },

      isShipmentReadonly
    }
  },

  computed : {
    ...mapGetters(['shipmentFilter', 'userInfo', 'globalConfig']),

    pages() {
      if (this.pagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0;

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage);
    },

    headerFilters() {// for debug purposes
      return this.headers.map(elem => elem.filter);
    },

    filtersOn() {
      let flat = {};// for stringify
      let filters = this.headers.concat(this.filters);
      for (let x = 0; x < filters.length; x++) {
        let fval = filters[x].filter;
        // no filter value
        if (typeof fval === "undefined" || fval === null || fval.length === 0)
          continue;

        let name = filters[x].filterName;
        if (!name)
          name = filters[x].value;

        // add the filter
        if (name === "order_date" || name === "state_date" || name === "source_date" || name === "target_date") {
          // not date filter
          if (!fval.since && !fval.until)
            continue;

          // by either of the dates
          if (fval.since && !fval.until)
            flat[name] = fval.since;
          else
          if (!fval.since && fval.until)
            flat[name] = fval.until;
          // or both dates
          else {
            if (new Date(fval.since) > new Date(fval.until)) {// Swap dates
              let osince = fval.since;
              fval.since = fval.until;
              fval.until = osince;
            }
            let  name_ = (name === "order_date" ? "" : name.split("_")[0] + "_");
            flat[name_ + "since"] = fval.since;
            flat[name_ + "until"] = fval.until;
          }
        }
        else
        if (name === "creator") {
          if (!fval.creator_type && !fval.creator_user)
            continue;

          if (fval.creator_type)
            flat["creator_type"] = fval.creator_type;
          if (fval.creator_user)
            flat["creator_user"] = fval.creator_user;
        }
        else {
          if (name === "weight" || name === "cash_on_delivery.amount" || name === "price.amount") {
            let//
            n = (fval.startsWith("<") || fval.startsWith(">")) ? fval.substring(1) : fval;
            // skip invalid numbers, as they will crash the backend
            if (isNaN(parseFloat(n)))
              continue;
          }
          flat[ name ] = fval;
        }
      }
      return flat;
    },

    strFiltersOn() {
      let fstr = [];
      Object.keys( this.filtersOn ).forEach(key => {
        if (key.startsWith('creator'))
          key = 'creator';
        else
        if (key === 'since' || key === 'until')
          key = 'order_date';
        else
        if (key.endsWith('since') || key.endsWith('until'))
          key = key.split('_')[0] + '_date';

        let header = this.headers.find(header => header.filterName === key || header.value === key);
        if (header && !fstr.includes(header.text))
          fstr.push(header.text);
      });
      return fstr.join(', ');
    },

    serviceTypes() {
      return getDefaultServiceTypes();
    },

    acceptedIds() {
      return this.selected.filter(elem => elem.accepted).map(elem => elem.id);
    },

    notAcceptedIds() {
      return this.selected.filter(elem => !elem.accepted).map(elem => elem.id);
    },

    cancellableIds() {
      return this.selected.filter(elem => elem.cancellable).map(elem => elem.id);
    },

    filterMore() {
      return this.filters.find(elem => elem.filterName === 'more');
    }
  },

  watch: {
    pagination: {
      handler() {
        this.store();
        this.loadDataFromApi('Pagination watch handler');
      },
      deep: true
    },
    filtersOn: function(value, oldValue) {
      let o = JSON.stringify(oldValue);
      let v = JSON.stringify(value);
      if (o !== v && !!this.itemsLoaded) {
        this.store();
        this.filter();
      }
    }
  },

  created() {
    this.filter = debounce(() => {
      if (this.pagination.page == 1) {
        this.loadDataFromApi('Debounce by filters watcher');
      }
      else {
        // Triggers pagination watcher to loadDataFromApi()
        this.pagination.page = 1;
      }
    }, 1200);
  },

  mounted() {
    {// reStored
      let storedFilter = null;
      try {
        storedFilter = JSON.parse(this.shipmentFilter);
      } catch(e) {
        storedFilter = null;
      }

      if (storedFilter) {
        if (storedFilter.pagination)
          this.pagination = storedFilter.pagination;

        storedFilter.shown.forEach((val, idx) => {
          this.headers[idx].show = val;
        });

        if (storedFilter.filters) {
          storedFilter.filters.forEach(stored => {
            // Additional filters
            let filtersMatch = this.filters.find(filter => filter.filterName === stored.filterName);
            if (filtersMatch) {
              console.log('mounted filtersMatch=', filtersMatch);
              filtersMatch.filter = stored.filter;
            }
            else {// Headers
              let header = this.headers.find(header => header.filterName === stored.filterName || header.value === stored.filterName
                                                   || (header.value      ===  'order_date' && (stored.filterName ===  'order_date' || stored.filterName ===        'since' || stored.filterName ===        'until'))
                                                   || (header.value      ===  'state_date' && (stored.filterName ===  'state_date' || stored.filterName ===  'state_since' || stored.filterName ===  'state_until'))
                                                   || (header.filterName === 'source_date' && (stored.filterName === 'source_date' || stored.filterName === 'source_since' || stored.filterName === 'source_until'))
                                                   || (header.filterName === 'target_date' && (stored.filterName === 'target_date' || stored.filterName === 'target_since' || stored.filterName === 'target_until'))
                                                   || (header.value === 'creator' && stored.filterName.startsWith('creator'))
                                            );
              //console.log('mounted header=', JSON.stringify(header, null, 4));
              if (header) {

                if (header.value === 'order_date' || header.value === 'state_date' || header.filterName === 'source_date' || header.filterName === 'target_date') {
                  let since = (header.value === 'order_date' ? '' : header.value.split('_')[0] + '_') + 'since';
                  let until = (header.value === 'order_date' ? '' : header.value.split('_')[0] + '_') + 'until';

                  if (stored.filterName === 'order_date' ||
                      stored.filterName === 'state_date' ||
                      stored.filterName === 'source_date' ||
                      stored.filterName === 'target_date' || stored.filterName === since)
                    header.filter = {
                      'since': stored.filter,
                      'until': null
                    }
                  else
                  if (stored.filterName === until)
                    header.filter.until = stored.filter;
                }
                else
                if (header.value === 'creator') {
                  header.filter = {
                    'creator_type': stored.filterName === 'creator_type' ? stored.filter : header.filter['creator_type'],
                    'creator_user': stored.filterName === 'creator_user' ? stored.filter : null
                  }
                  //if (stored.filterName === 'creator_type')
                  //  header.filter = {
                  //    'creator_type': stored.filter,
                  //    'creator_user': null
                  //  }
                  //if (stored.filterName === 'creator_user')
                  //  header.filter.creator_user = stored.filter;
                }
                else
                  header.filter = stored.filter;
              }
              //console.log('mounted after,  stored.filterName=', stored.filterName, ', header.value=', header.value, ', header.filter=', JSON.stringify(header.filter, null, 4));
            }
          });
        }
      }
      //if (!this.pagination.sortBy) {
      //  const sortByDefault = this.headers.find(elem => !!elem.sortBy);
      //  if (sortByDefault) {
      //    this.pagination.sortBy = sortByDefault.value;
      //    this.pagination.descending = true;
      //  }
      //}
    }

    shipments.listStates().then(res => {
      this.states = res.body.result;
    }).catch(err => {
      console.log("Cannot load states");
      this.states = [];
    }).finally(() => {
    });

    //this.loadDataFromApi('Mounted');
  },

  methods: {
    ...mapActions(['updateShipmentFilter']),

    loadDataFromApi(text) {
      this.getDataFromApi().then(data => {
        this.items = data.items;
        this.totalItems = data.total;
        this.itemsLoaded = true;

        this.bulkLoadAttachments();
      }).catch(data => {
        console.log(text + ' loading rejected.', data);
      });
    },

    getDataFromApi() {
      if (this.loading)
        return new Promise((resolve, reject) => { reject(); });

      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;

        this.loading = true;
        let offset = (page>=1 && rowsPerPage>=1) ? (page - 1) * rowsPerPage : 0;
        let length = (rowsPerPage>=1) ? rowsPerPage : -1;
        let sort   = (sortBy) ? (descending ? "-" : "") + sortBy : "";
        let//
        params = this.filtersOn;
        if (sort)
          params = Object.assign({ length, offset, sort }, params);
        else
          params = Object.assign({ length, offset }, params);

        shipments.list(params).then(response => {
          resolve({
            items: response.body.result,
            total: response.body.length
          });
        }).catch(response => {
          this.msg.popup((
            response.status === 403 ?  this.$t("Access denied") : response.statusText
          ), 'error');
          reject("Error loading shipment list " + response.status);
        }).finally(() => {
          this.loading = false;
        });
      });
    },

    showPackagingType(val) {
      return val.replace(/(\D*)x(.*)/, "$1 x $2");
    },

    showShipmentState(val) {
      if (val && val.code)
        return this.$t("ShipmentRoutingState." + val.code);

      return "";
    },

    /** param `field` is object `source` or `target` */
    showDateRange(field) {
      if (field && (field.after || field.until)) {
        let after = this.formatDatetime(field.after);
        let until = this.formatDatetime(field.until);
        if (after.substring(0, 10) == until.substring(0, 10)) {
          // 2021-08-12 14:30-18:00
          until = until.substring(11);
        }
        return after + ' - ' + until;
      }

      return "";
    },

    /** on type==
        CLIENT_USER    > user
        GENERIC_IMPORT > "Директна интеграция" - user=null
        COMPANY_USER   > "Транспрес служител"  - user=null
      */
    showCreator(field) {
      if (field && field.type) {
        if (field.type === 'CLIENT_USER')
          return field.user;
        else
          return this.$t('CREATOR_TYPE.' + field.type);
      }
    },

    getStateIcon(obj) {
      return getStateIcon(obj).stateIcon;
    },

    getObjectIcon(obj, idx) {
      if (this.headers[idx].value !== 'state' && this.headers[idx].type !== 'boolean')
        return undefined;

      let v = _object.get(obj, this.headers[idx].value);
      if (this.headers[idx].type === 'boolean')
        return this.getBoolIcon(v);
      return this.getStateIcon(v);
    },
    getBoolIcon(val) {
      if (val === undefined || val === null)
        return 'remove';
      return val ? 'check' : 'close';
    },

    getObjectValue(obj, idx, header) {
      let v = _object.get(obj, this.headers[idx].value);
      let t = this.headers[idx].type;

      if (typeof t === 'function') {
        return t(v, header.value === 'price');
      }
      else
      if (t === 'date')
        return v ? this.formatDatetime(v, true) : '';
      else
      if (t === 'datetime')
        return v ? this.formatDatetime(v) : '';
      else
      if (t === 'enum' && v) {
        let e = this.headers[idx].enum;
        if (!e) e = "Enum";
        return this.$t(e + '.' + v);
      }

      if (typeof v === 'boolean')
        return this.$t('Boolean.' + v);

      if (typeof v === 'number')
        return v.toLocaleString();

      return v;
    },

    columnHideCheck(header) {
      if (!header.show)
        return false;

      let v = 0;
      for (let i = 0; i < this.headers.length; i++)
        if (this.headers[i].value != 'actions' && this.headers[i].show)
          v++;

      return (v<2);
    },

    getColumnAlign(idx) {
      if (this.headers[idx].align)
        return "text-xs-" + this.headers[idx].align;
      return "text-xs-left";
    },

    getRowBackground(item) {
      if (!item.accepted)
        return 'orange lighten-4'
      if (!item.collected)
        return 'lime lighten-4'
      return '';
    },

    getFieldType(idx) {
      let val = this.headers[idx].value;
      if (val == 'cash_on_delivery' || val == 'weight')
        return 'text';
      else if (val == 'order_date' || this.headers[idx].type === 'date')
        return 'date';
      else return 'text';
    },

    store() {
      const shown = this.headers.filter(header => header.value !== 'actions')
                                .map(header => !!header.show);

      const filters = Object.keys(this.filtersOn)
        .filter(key => key !== 'more')
        .map(key => ({
            filterName: key,
            filter: this.filtersOn[key]
          })
        );

      let s = {
        pagination: this.pagination,
        shown:   shown,
        filters: filters
      };
      this.updateShipmentFilter(JSON.stringify(s));
    },

    changeSort(header) {
      if (!header.sortable)
        return;
      let column = header.value;
      if (this.pagination.sortBy === column) {
        if (this.pagination.descending)
          this.pagination.sortBy = null;
        else
          this.pagination.descending = true;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    hasFilter(header) {
      if (header.value === 'order_date' || header.value === 'state_date' || header.filterName === 'source_date' || header.filterName === 'target_date')
        return (!!header.filter.since || !!header.filter.until);
      if (header.value === 'creator')
        return (!!header.filter.creator_type || !!header.filter.creator_user);
      if (Array.isArray(header.filter))
        return header.filter.length > 0;
      return !!header.filter;
    },

    filterTooltip(header) {
      if (header.value === 'order_date' || header.value === 'state_date' || header.filterName === 'source_date' || header.filterName === 'target_date') {
        let x = '';
        if (!!header.filter.since && !!header.filter.until) {
          x = this.$t('from') + ' ' + header.filter.since + ', ' + this.$t('to') + ' ' + header.filter.until;
        }
        else if (!!header.filter.since || !!header.filter.until) {
          x = this.$t('on') + ' ' + (header.filter.since ? header.filter.since : header.filter.until);
        }
        return x;
      }
      else
      if (header.value === 'creator') {
        let x = '';
        x = this.$t('CREATOR_TYPE.' + header.filter.creator_type);
        if (header.filter.creator_user) {
          x += ' - ' + header.filter.creator_user;
        }
        return x;
      }
      else
      if (Array.isArray(header.filter)) {
        let x = '';
        for(let i = 0; i < header.filter.length; i++) {
          let v = header.filter[i];
          if (header.value === 'state') {
            let s = this.states.find(function(e) {
              return e.code === v;
            });
            if (!s) continue;

            if (x.length > 0)
              x = x + ', ';
            x = x + s.display.substring(0, 3);
          }
          else if (header.value === 'service_type') {
            if (x.length > 0)
              x = x + ', ';
            x = x + this.$t('ServiceType.' + v);
          }
        }
        return x;
      }
      return header.filter;
    },

    resetFilters() {
      //this.headers.concat(this.filters).forEach(header => {
      this.headers.forEach(header => {
        if (typeof header.filter !== 'undefined') {
          if (typeof header.filter === 'object' && !Array.isArray(header.filter) && header.filter !== null) {
            Object.keys(header.filter).forEach(key => {
              header.filter[key] = null;
            });
          }
          /* not removed for backup
          if (header.value === 'order_date')
            header.filter = { since: null, until: null };
          else
          if (header.value === 'creator')
            header.filter = { creator_type: null, creator_user: null };
          */
          else
            header.filter = null;
        }
      });
    },

    getFilter(name) {
      return this.filters.find(elem => elem.filterName === name);
    },

    onFilter(name, falsyValue) {
      this.getFilter(name).filter = this.getFilter(name).filter ? (
        typeof falsyValue !== 'undefined' ? falsyValue : false
      ) : true;
    },

    onFilterMore() {
      if (!this.filterMore.filter) {
        if (this.filterMore.disabled) {
          return;
        }
        this.filterMore.allowing = true;
        this.filterMore.disabled = true;

        shipments.allowExtraList()
          .then(response => {
            let msgText = '';
            if (response.body && response.body.allow) {
              msgText = this.$t('Shipments.More.Allowed.Alert');
              this.filterMore.filter = true;
            }
            else {
              msgText = this.$t('Shipments.More.NotAllowed.Alert');
              this.filterMore.filter = null;
            }
            this.msg.popup(msgText, 'warning');
          }).catch(error => {
            this.msg.popup(error.statusText, 'error');
            this.filterMore.filter = null;
          }).finally(() => {
            setTimeout(() => this.filterMore.disabled = false, 5000);
            this.filterMore.allowing = false;
          });
      }
      else {
        this.filterMore.filter = null;
      }
    },

    editItem(item) {
      this.$router.push({ name: "request", params: { id: item.id }});
    },

    editItemAsNew(item) {
      this.$router.push({ name: "request", params: { id: item.id, IS_CLONE: true }});
    },

    trackItem(item) {
      if (!item || !item.manifest)
        return;
      let manifest = item.manifest.replace(/\#/, '%23');
      //this.$router.push({ name: "track_id", params: { id: manifest }});
      let win = window.open(location.origin + __webpack_public_path__ + '#/track/' + manifest, '_blank');
      win.focus();
    },

    routeTrackItem(item) {
      this.routeTracking = {
        shipment: item,
        show: true
      }
    },

    printMenu(item) {
      if (this.loading || (!item && this.acceptedIds.length == 0))
        return;

      let usr = this.userInfo;
      if (usr && usr.options && usr.options.showPrice)
        this.printOpts.price = usr.options.showPrice;
      if (usr && usr.options && usr.options.showInsurance)
        this.printOpts.insurance = usr.options.showInsurance;

      this.printOpts.items = item ? [item.id] : this.acceptedIds;

      this.printOpts.show = true;
    },
    printItem() {
      if (this.loading)
        return;
      if (!this.printOpts.items || this.printOpts.items.length == 0)
        return;

      this.loading = true;

      let//
      print = {
        insurance: this.printOpts.insurance,
        price: this.printOpts.price,
        shipmentIds: this.printOpts.items
      };

      shipments.printManifest( print ).then(response => {
        downloadFile(response);
      }).catch(error => {
        this.msg.popup(this.$t('Error downloading manifest PDF'), 'error');
      }).finally(() => {
        this.loading = false;
      });
    },

    labelItem(item) {
      if (this.loading)
        return;
      if (!item && this.acceptedIds.length == 0)
        return;
      //
      this.loading = true;
      //
      let//
      itemIds = this.acceptedIds;
      if (itemIds.length == 0)
        itemIds = [item.id];
      shipments.printLabel( itemIds ).then(response => {
        downloadFile(response);
      }).catch(error => {
        this.msg.popup(this.$t('Error downloading label PRN files'), 'error');
      }).finally(() => {
        this.loading = false;
      });
    },

    exportPdf() {
      this.msg.popup(this.$t('Not implemented'), 'info');
    },

    exportExcel() {
      if (this.loading)
        return;
      //
      this.loading = true;

      let//
      params = this.filtersOn;

      shipments.xls(params).then(response => {
        downloadFile(response);
      }, error => {
        this.msg.popup(error.statusText, 'error');
      }).finally(() => {
        this.loading = false;
      });
    },

    bulkLoadAttachments() {
      this.items.forEach(elem => {
        if (elem.return_pod) {
          this.podInfo(elem);
        }
      });
    },
    podInfo(shipment) {
      this.$set(shipment, 'attachmentLoading', true);

      attachments.podInfo({
        shipmentId: shipment.id
      }).then(r => {
        if (r.body && r.body.pods) {
          this.$set(shipment, 'attachments', r.body.pods.map(elem => ({ ...elem, type: 'POD' })));
        }
        this.$set(shipment, 'attachmentLoading', false);
      }).catch(e => {
        this.msg.popup(this.$t('Error loading pod info'), 'error');

        this.$set(shipment, 'attachments', []);
        console.log('Error pod info', e);
      }).finally(() => {
        this.$set(shipment, 'attachmentLoading', false);
      });
    },
    getAttachmentsLength(attachments) {
      return attachments ? attachments.length : null;
    },
    getAttachmentColor(type) {
      const attch = attachmentTypes.find(elem => elem.id === type);
      if (! attch)
        return '';
      return attch.color;
    },
    downloadAttachment(shipment, attachmentId) {
      if (shipment.attachmentLoading) {
        return;
      }
      this.$set(shipment, 'attachmentLoading', true);

      let params = {
        shipmentId: shipment.id
      }
      if (attachmentId) {
        params.attachmentId = attachmentId;
      }
      else {
        params.manifest = shipment.manifest;
      }
      const endpoint = attachmentId ? 'podLoad' : 'podLoadByShipment';
      console.log('Download endpoint: ' + endpoint + ' with params: ', params);

      attachments[endpoint]( params ).then((response) => {

        downloadFile(response);
        let filename = '';
        const cd = response.headers.map['content-disposition'];
        if (cd && cd[0]) {
          const match = cd[0].match( /filename=\"?([^"]+)(?:\"?|$)/ );
          filename = match ? match[1] : '';
        }
        this.msg.popup(this.$t('ATTACHMENT.SHIPMENT.DOWNLOADED', [filename]), 'success');

      }).catch((err) => {
        console.log('Error downloading file', err);

        this.msg.popup( extractBodyErrorMessages(err.body) || this.$t('Error downloading file'), 'error' );

      }).finally(() => {
        this.$set(shipment, 'attachmentLoading', false);
      });
    },

    orderItems() {
      if (this.notAcceptedIds.length == 0) return;
      if (this.loading) return;
      //
      this.loading = true;
      //
      let //
        itemIds = this.notAcceptedIds;

      return shipments
        .request(itemIds)
        .then((response) => {
          const processed = response.body && response.body.processed;
          if (Array.isArray(processed)) {
            const errors = processed
              .filter((result) => !result.success)
              .map(
                (result) =>
                  extractBodyErrorMessages(result) ||
                  this.$t("Error ordering shipments")
              );
            if (errors.length > 0) {
              this.msg.popup(escape(errors.join("; ")), "error");
            }
          } else {
            this.msg.popup(this.$t("Error ordering shipments"), "error");
          }
          this.loading = false;
          this.loadDataFromApi("After shipment request");
        })
        .catch((error) => {
          this.msg.popup(
            escape(
              extractBodyErrorMessages(error.body) ||
                this.$t("Error ordering shipments")
            ),
            "error"
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    cancelItems() {
      let items = this.cancellableIds;
      this.loading = true;

      this.doCancelItem(items, 0);
    },

    doCancelItem(items, cnt) {
      if (items.length === 0){
        this.loading = false;
        let msgText = this.$t("Cancelled") + " " + cnt + " " + this.$t("orders");
        this.msg.popup(msgText, 'info');
        // reload data as list might be changed
        if (cnt > 0)
          this.loadDataFromApi("After cancel");
        //
        return;
      }

      let ok = false;
      let id = items.shift();

      shipments.cancel({ id }).then((response) => {
        ok = true;
        this.selected.shift();
      }).catch((error) => {
        console.log("Error cancelling shipment #" + id, error);
      }).finally(() => {
        if (ok) cnt ++;
        this.doCancelItem(items, cnt);
      });
    },

    formatDatetime(timestamp, dateOnly) {
      if (!timestamp) return "";
      let d = new Date( timestamp ),
          year  = d.getFullYear(),
          month = ("0" + (d.getMonth()+1) ).slice(-2),
          day   = ("0" +  d.getDate()     ).slice(-2),
          hour  = ("0" +  d.getHours()    ).slice(-2),
          min   = ("0" +  d.getMinutes()  ).slice(-2);
      let time = `${hour}:${min}`,
          date = `${day}.${month}.${year}`;
      return dateOnly ? `${date}` : `${date} ${time}`;
    },

    toggleAll() {
      if (this.selected.length)
        this.selected = [];
      else
        this.selected = this.items.slice();
    },

    filterFocus(idx) {
      let elem = document.getElementById('filter-' + idx + '-body');
      if (elem) {
        setTimeout( () => elem.focus(), 500);
      }
    },

    getMaxDate(val) {
     if (val == 'source_date' || val == 'target_date') {
        return null;
      }
    }
  }
}
</script>

<style scoped>
.v-badge--overlap >>> .v-badge__badge {
  width: 18px;
  height: 18px;
  top: -4px;
  right: -4px;
  font-size: 85%;
}
.float-right {
  float: right;
}
.attachment-tooltip {
  margin-top: -32px;
}
</style>

<style>
/*========== Table header's Filters ==========*/

/*---------- IE/Chrome: Filter width too short to fit input controls (they are clipped or smashed) ----------*/
.shipments-filter.v-menu__content {
  overflow: visible !important;
}
@media all and (-ms-high-contrast:none) {/* IE */
  .shipments-filter.v-menu__content { width: 360px !important; } /* IE10 */
  /*  *::-ms-backdrop, .foo { min-width: 360px !important; } /* IE11 */
}
@media screen and (-webkit-min-device-pixel-ratio:0) {/* Chrome */
  .shipments-filter.v-menu__content {
    contain: none !important;
    max-width: 450px !important;
  }
}

/* State filter's v-select: v-chip (must be in vuetify.min.css) */
.shipments-filter .chip--select-multi {
  margin: 4px 4px 4px 0;
  min-width: 10rem; /* set chip's width same for all and arrange in two columns */
}
.shipments-filter .v-chip .v-avatar {
  overflow: hidden;
}
/* FIX v-select's height 200px limit */
.shipments-filter .v-menu__content.theme--light.v-menu__content--auto.menuable__content__active {
  max-height: inherit !important;
}
.shipments-filter .v-chip.chip--select-multi .v-chip__content {
  width: 100%;
}

/* State filter's v-select: Emphsizes selected option */
.theme--light.v-list .v-list__tile--active::after {
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  background-color: currentColor;
  right: 0;
  bottom: 0;
  opacity: .12;
}
.shipments-filter .v-input__icon.v-input__icon--clear {
  z-index: 1;
}

/* Filter icon */
.v-datatable thead th .filter {
  margin-left: 16px;
}
.v-datatable thead th.column.active.desc .filter .v-icon {
  -webkit-transform: none;
  transform: none;
}
.v-datatable thead th.column:not(:hover) .filter:not(:hover) .v-icon {
  opacity: 0;
}
.v-datatable thead th.column .filter:hover .v-icon,
.v-datatable thead th.column .filter:focus .v-icon,
.v-datatable thead th.filtered .filter .v-icon {
  opacity: 1 !important;
}
/* Filtered column icon n label */
.v-datatable thead th.filtered .filter .v-icon {
  color: #0d47a1 !important;
}
.v-datatable thead th.filtered > div > div:nth-child(2) {
  font-weight: 700;
  color: #0d47a1;
}

/* Table rows border fix */
.shipments-table .theme--light.v-table tbody tr:not(:last-child) {
  border-bottom: 1px solid rgba(0,0,0,.12) !important;
}
/* Table last col's filter-menu right space fix */
.shipments-table .v-table thead th > div {
  width: auto !important;
  line-height: 1.1;
}
.shipments-table .v-table > tbody > tr > td {
  line-height: 1.1rem;
}

/*---------- Table: sticky cols and colorized rows ----------*/

/* Table sticky cols */
.sticky-left, .sticky-right {
  position: sticky;
  z-index: 1;
  background-clip: padding-box;
  background-color: white;
}
.sticky-left {
  left: 0;
}
.sticky-right {
  white-space: nowrap;
  right: 0;
}
.sticky-left:nth-child(1) {
  width: 48px;
  padding-left: 8px !important; /* = px-2 */
  padding-right: 8px !important;
}
.sticky-left:nth-child(2) {
  left: 48px; /* :nth-child(1) px-2 */
}
.sticky-left.outer,
.shipments-table .v-table > tbody > tr > td:nth-child(2) {
  background-image: linear-gradient(to right, #ffff 75%, #fff0 100%); background-color: transparent;
}
.sticky-right.outer {
  background-image: linear-gradient(to left, #ffff 75%, #fff0 100%); background-color: transparent;
}
th.sticky-left, th.sticky-right {
  border-top: solid 1px transparent !important;
}
td.sticky-left, td.sticky-right {
  /* border-bottom: 1px solid transparent !important; */
}

/* Table rows colors */
.orange.lighten-4 .sticky-left,
.orange.lighten-4 .sticky-right {
  background-color: #ffd698;/* #ffe0b2; hsl(hsl(35.8, 100%, 81.9->79.9%)) */
}
.lime.lighten-4 .sticky-left,
.lime.lighten-4 .sticky-right {
  background-color: #ebf0ae;/* #f0f4c3; hsl(64.9, 69%, 86.1->81.5%) */
}
.orange.lighten-4 .sticky-left.outer {
  background-image: linear-gradient(to right, #ffd698ff 75%, #ffe0b200 100%); background-color: transparent;
}
.orange.lighten-4 .sticky-right.outer {
  background-image: linear-gradient(to left, #ffd698ff 75%, #ffe0b200 100%); background-color: transparent;
}
.lime.lighten-4 .sticky-left.outer {
  background-image: linear-gradient(to right, #ebf0aeff 75%, #f0f4c300 100%); background-color: transparent;
}
.lime.lighten-4 .sticky-right.outer {
  background-image: linear-gradient(to left, #ebf0aeff 75%, #f0f4c300 100%); background-color: transparent;
}

/* Even rows + rows hover: .even = .lighten-3 */
.shipments-table .v-table > tbody > tr.even {
  background-color: #f6f6f6 !important;
}
.shipments-table .v-table > tbody > tr.orange.lighten-4.even {
  background-color: #ffcc80 !important;
}
.shipments-table .v-table > tbody > tr.lime.lighten-4.even {
  background-color: #dfe893 !important;
}

.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
  box-shadow: inset 0px 2px 9px rgba(0,0,0,0.25);
}

/* 2021-12-23 commented: solid fill on hover, but bottom-border disapears
.shipments-table .v-table > tbody > tr:hover > td,
.shipments-table .v-table > tbody > tr:hover > .sticky-left,
.shipments-table .v-table > tbody > tr:hover > .sticky-right {
  background: #e9e9e9 !important;
  border-bottom: 1px solid rgba(0,0,0,0) !important;
}
.shipments-table .v-table > tbody > tr.orange.lighten-4:hover > td,
.shipments-table .v-table > tbody > tr.orange.lighten-4:hover > .sticky-left,
.shipments-table .v-table > tbody > tr.orange.lighten-4:hover > .sticky-right {
  background: #ffc267 !important;
  border-bottom: 1px solid rgba(0,0,0,0) !important;
}
.shipments-table .v-table > tbody > tr.lime.lighten-4:hover > td,
.shipments-table .v-table > tbody > tr.lime.lighten-4:hover > .sticky-left,
.shipments-table .v-table > tbody > tr.lime.lighten-4:hover > .sticky-right {
  background: #e0ea86 !important;
  border-bottom: 1px solid rgba(0,0,0,0) !important;
}
*/
/*---------- /Table: sticky cols and colorized rows ----------*/
</style>
